import { CreateMenuItemContent } from 'components/CreateMenuItemContent';

export const CreateBrandVoiceMenuItemContent = () => (
  <CreateMenuItemContent messageId="brand_voice.select.create_new" />
);
